// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2JquB","list":"BalanceDue_list__T9_4K","listRow":"BalanceDue_listRow__29L5E","total":"BalanceDue_total__2iicT"};